import { Component, inject } from '@angular/core';
import { Block, BlockAbstractComponent, ZoneService } from '@gallaghercp/core-frontend';
import { isExternalLink } from '@core-app/utils/link.util';

@Component({
    selector: 'core-block-feature-card-grid',
    templateUrl: './block-feature-card-grid.component.html',
    styleUrl: './block-feature-card-grid.component.scss',
    standalone: false,
})
export class BlockFeatureCardGridComponent extends BlockAbstractComponent {
    private zoneService = inject(ZoneService);

    parseImageUrl(url: string): string {
        return url.replace('/api/1.0/download', '/file');
    }

    // Use values as-provided from API; fallback to safe defaults only when missing
    normalizeCta(card: any): { ctaVariant: string; ctaTextColor: string; btnColor: string } {
        const ctaVariant = (card?.data?.btnVariant as string) ?? 'solid';
        const ctaTextColor = (card?.data?.btnColor as string) ?? 'primary';
        const btnColor = (card?.data?.btnColor as string) ?? 'primary';
        return { ctaVariant, ctaTextColor, btnColor };
    }

    isExternalLink(block: Block): boolean {
        const url = block.data.ctaLink;

        // If we have external link set as true on the CMS side, always return true.
        if (block.data.isExternalLink) return true;

        return isExternalLink(url);
    }

    getRouterLink(url: string): string {
        return this.zoneService.injectZoneCodeUrl(url);
    }
}
